var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#081319;}")),React.createElement("path",{"d":"M11.69,13.86h2.52v8.52H11.69Z","key":1}),React.createElement("path",{"d":"M16.38,13.86h2.23v1.08h.07a6.72,6.72,0,0,1,1.2-.9,2.9,2.9,0,0,1,1.53-.38,2.25,2.25,0,0,1,2,.91,4.35,4.35,0,0,1,.63,2.52v5.29H21.53v-5a2.33,2.33,0,0,0-.25-1.27.94.94,0,0,0-.8-.35,1.49,1.49,0,0,0-.83.22,4.47,4.47,0,0,0-.75.61v5.75H16.38Z","key":2}),React.createElement("ellipse",{"cx":"12.95","cy":"10.92","rx":"1.75","ry":"1.76","key":3}),React.createElement("path",{"d":"M17,1A16,16,0,1,0,33,17,16,16,0,0,0,17,1Zm0,31A15,15,0,1,1,32,17,15,15,0,0,1,17,32Z","key":4})]);
}

Linkedin.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
